import {add_to_cart, out_of_stock} from 'Components/ProductDetail/product.module.scss'
import { useMutation, useQuery } from '@apollo/client';

import ADDTOCART_MUTATION from 'Mutations/ADDTOCART';
import { AppContext } from 'Context/AppContext';
import GET_CART from 'Queries/GET_CART';
import Loading from 'Components/SpinnerLoader/Loading';
import { OUT_OF_STOCK } from 'Lib/constants/product';
import classNames from 'classnames';
import { getFormattedCart } from 'functions';
import { useContext } from 'react';
import { v4 } from 'uuid';

export default function AddToCartButton(props) {
  const {
    productId,
    buttonIcon,
    className,
    text = 'Thêm vào giỏ hàng',
    loadingComponent = 'Đang thêm...'
  } = props;
  const [, setCart] = useContext(AppContext);
  const addToCartInput = {
    clientMutationId: v4(),
    productId: productId
  };

  // Get Cart Data.
  const { data, refetch } = useQuery(GET_CART, {
    notifyOnNetworkStatusChange: true,
    fetchPolicy: 'cache-and-network',
    onCompleted: () => {
      // Update cart in the localStorage.
      const updatedCart = getFormattedCart(data);
      localStorage.setItem('woo-next-cart', JSON.stringify(updatedCart));
      setCart(updatedCart);
    }
  });

  const [
    addToCart,
    { data: addToCartRes, loading: addToCartLoading, error: addToCartError }
  ] = useMutation(ADDTOCART_MUTATION, {
    variables: {
      input: addToCartInput
    },
    onCompleted: () => {
      refetch();
    }
  });

  const handleAddToCart = async () => {
    if (productId) {
      await addToCart();
    }
  };

  return (
    <>
      {addToCartLoading && <Loading />}
      <button className={classNames(add_to_cart, className)} onClick={handleAddToCart}>
        {buttonIcon}
        <span>{addToCartLoading ? loadingComponent : text}</span>
      </button>
    </>
  );
}
